// ResponsablePage.tsx
import { MRT_ColumnDef } from "material-react-table";
import { useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { GeneralTable, SingleTableBoxScene, SwitchComponente } from "@/shared/components/ui";
import {
  useFetchGetResponsables,
  useFetchDeleteResponsable,
  useFetchPatchEstadoResponsable
} from "@/shared/actions";
import { MRT_ColumnFiltersState } from 'material-react-table';
import {
  ROUTER_PATHS,
  TABLE_CONSTANTS_COLUMS,
  useTableFilter,
  // useTableServerSideFiltering,
} from "@/shared";
import { useUiConfirmModalStore } from "@/store/ui";
import { Responsable } from "../../types";

//
import { useAuthStore } from "@/store/auth/auth.store"; 
import { useUserModulesStore } from "@/store/auth";       
import { SystemModulesEnum } from "@/auth/interfaces";
import { Outlet } from "react-router-dom";
import { toFilterParams } from "@/erp/controlcambios/servidores";
export default function ResponsablePage() {

  const user = useAuthStore((s) => s.user) as any; 
      const userModules = useUserModulesStore((s) => s.modules);  
      const isSuper = !!user?.is_superuser || !!user?.is_staff; 
      const tineAccesoAreacontrolAreas = userModules.includes(SystemModulesEnum.CONTROL_CAMBIOS_RESPONSABLES) 
  const returnUrl = ROUTER_PATHS.control_cambios.responsableNav;
  const navigate = useNavigate();
  const setConfirmDialog = useUiConfirmModalStore((s) => s.setConfirmDialog);
  const setConfirmDialogIsOpen = useUiConfirmModalStore(
    (s) => s.setConfirmDialogIsOpen
  );

  const { pagination, setPagination } = useTableFilter();
  const { pageIndex, pageSize } = pagination;
  // const { columnFilters, setColumnFilters } = useTableServerSideFiltering();
 const [columnFilters, setColumnFilters] = useState<MRT_ColumnFiltersState>([]);
  const {
    data: response,
    isLoading,
    isRefetching,
  } = useFetchGetResponsables({
    page: pageIndex,
    size: pageSize,
    ...toFilterParams(columnFilters),
  });
  


  const deleteResponsable = useFetchDeleteResponsable();
  const patchEstado = useFetchPatchEstadoResponsable();



  const onEdit = (original: Responsable) => {
    setConfirmDialog({
      isOpen: true,
      title: "Editar responsable",
      subtitle: "¿Está seguro que desea editar este registro?",
      onConfirm: () => {
        setConfirmDialogIsOpen(false);
        navigate(`${returnUrl}/editar/${original.responsableId}`);
      },
    });
  };

  const onDelete = (origin: Responsable) => {
    setConfirmDialog({
      isOpen: true,
      title: "Eliminar responsable",
      subtitle: `¿Está seguro que desea eliminar el responsable "${origin.cargo}"? Esta acción no se puede deshacer.`,
      onConfirm: () => {
        setConfirmDialogIsOpen(false);
        deleteResponsable.mutate(origin.responsableId!);
      },
    });
  };

  const columns = useMemo<MRT_ColumnDef<Responsable>[]>(
    () => [
      {
        accessorKey: "cargo",
        header: "Cargo",
        size: 160,
        Cell: ({ row }) => row.original?.cargo || "N/A",
      },
      {
        accessorKey: "razon_social",
        header: "Usuario (razón social)",
        size: 220,
       Cell: ({ row }) => row.original?.razonSocial ?? "No disponible",
      },
      {
        accessorKey: "correo",
        header: "Correo",
        size: 220,
        Cell: ({ row }) => row.original?.correo || "N/A",
      },
      {
        accessorKey: "telefono",
        header: "Teléfono",
        size: 140,
        Cell: ({ row }) => row.original?.telefono || "N/A",
      },
      {
        accessorKey: "estado",
        header: "Activo",
        size: 120,
        enableColumnFilter: false,
        Cell: ({ row }) => (
          <SwitchComponente
            estadoSwitch={!!row.original.estado}
            titulo={row.original.estado ? "Activo" : "Inactivo"}
            setEstadoSwitch={() => {
              setConfirmDialog({
                isOpen: true,
                title: "Cambiar estado",
                subtitle: "¿Seguro que desea cambiar el estado del servidor?",
                onConfirm: () => {
                  setConfirmDialogIsOpen(false);
                  patchEstado.mutate({ id: row.original.responsableId!, estado: !row.original.estado });
                },
              });
            }}
          />
        ),
      },
    ],
    []
  );
   if(!isSuper || !tineAccesoAreacontrolAreas){
  return (
    <SingleTableBoxScene
      title={"Responsables de control de cambios"}
      urlRedirect={`${returnUrl}/crear`}
      py={2}
    >
      <GeneralTable<Responsable>
        columns={columns}
        data={response?.data || []}
        isLoading={isLoading}
        isRefetching={isRefetching}
        enableGlobalFilter={false}
        enableManualFiltering={true}
        columnFilters={columnFilters}
        onColumnFiltersChange={setColumnFilters}
        pagination={pagination}
        onPaging={setPagination}
        rowCount={response?.totalElements ?? 0}
        actionsColumnSize={TABLE_CONSTANTS_COLUMS.ACTIONCOLUMN_WIDTH}
        positionActionsColumn="first"
        canEdit={true}
        onEdit={onEdit}
        canDelete={true}
        onDelete={onDelete}
      />
    </SingleTableBoxScene>
  );
   }
        return <Outlet />;
}
